import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  colorFilterState,
  hasSelectedColorFiltersSelector,
  resetSelectedColorFiltersSelector,
  selectColor,
  selectedColorFiltersSelector,
  toggleColor,
  visibleColorFiltersSelector,
} from '@/states/filters/colors.state';

export function useColorsFilter() {
  const [colorFilters, setColorFilters] = useRecoilState(colorFilterState);

  const toggleColorFilter = useSetRecoilState(toggleColor);
  const selectColorFilter = useSetRecoilState(selectColor);

  const selectedColorFilters = useRecoilValue(selectedColorFiltersSelector);
  const visibleColorFilters = useRecoilValue(visibleColorFiltersSelector);

  const resetSelectedColorFilter = useSetRecoilState(
    resetSelectedColorFiltersSelector
  );

  const hasSelectedColorFilters = useRecoilValue(
    hasSelectedColorFiltersSelector
  );

  return {
    colorFilters,
    setColorFilters,
    toggleColorFilter,
    selectedColorFilters,
    resetSelectedColorFilter,
    hasSelectedColorFilters,
    selectColorFilter,
    visibleColorFilters,
  };
}
